import React, { useState } from "react";
import clsx from "clsx";
import {
  makeStyles,
  Grid,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";

import PhoneIcon from "@material-ui/icons/Phone";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import EmailIcon from "@material-ui/icons/Email";
import StorefrontIcon from "@material-ui/icons/Storefront";
import CookieNotice from './CookieNotice';

import logo from "../../wtw_new_logo_white.svg";
import TermsOfUse from "./TermsOfUse";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > a": {
      marginBottom: ".5rem",
      display: "block",
      color: "#fff",
      fontSize: 12,
      cursor: "pointer",
    },
  },
  secondaryLinks: {
    "& > a": {
      color: theme.palette.text.hint,
    },
  },
  dialog: {
    "& * > svg": {
      marginBottom: "-3px",
      marginRight: ".2rem",
    },
    "& > h6": {
      marginTop: "1rem",
    },
  },
  appBar: {
      background: "#7F35B2",
    color: "#fff",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  logo: {
    marginLeft:'-10px',
    height: "50px",
    borderStyle: "none",
    marginBottom: ".5rem",
    [theme.breakpoints.only("xs")]: {
      maxWidth: "340px",
      marginBottom: "0",
    },
  },
  links: {
    color: "#d8d8d8",
    border: 0,
    [theme.breakpoints.only("xs")]: {
      marginTop: ".5rem",
      paddingTop: ".5rem",
      borderTop: "1px solid #2a2a2a",
    },
  },
  copyright: {
    marginTop: 15,
    paddingTop: 15,
    paddingBottom: 10,
    borderTop: "1px solid white",
    fontSize: 12,
  },
}));

const contactUs = {
  title: "Kontakta oss",
  content: (
    <>
      <Typography>
        <Link href="tel:+46 8 5463 5990">
          <PhoneIcon color="primary" /> +46 8 5463 5990
        </Link>
        <br />
        <Link href="mailto:saljservice@wtwco.com">
          <AlternateEmailIcon color="primary" /> saljservice@wtwco.com
        </Link>
      </Typography>
      <Typography variant="h6">
        <StorefrontIcon color="primary" /> Öppettider
      </Typography>
      <Typography>Vardagar 9-17</Typography>
      <Typography variant="h6">
        <EmailIcon color="primary" /> Postadress
      </Typography>
      <Typography>
        Willis Towers Watson Sweden AB
        <br /> Box 7273
        <br />
        103 89 Stockholm
      </Typography>
    </>
  ),
};

const Footer = () => {
  const styles = useStyles();
  const [open, toggleOpen] = useState(false);
  const [showCookie, setShowCookie] = useState(false);
  const [showTou, setShowTou] = useState(false);

  const clickHandler = (e) => {
    e.preventDefault();
    toggleOpen(true);
  };


  return (
    <div className={styles.appBar}>
      {showCookie && <CookieNotice onExit={() => setShowCookie(false)} />}
      {showTou && <TermsOfUse onExit={() => setShowTou(false)} />}
      <Container>
        <Grid item container direction="row">
          <Grid item xs={12} md={6}>
            <img alt="WTW Logo" src={logo} className={styles.logo} />
          </Grid>
          <Grid container item xs={12} md={6} justify="space-between" className={styles.links}>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" className={styles.root}>
                <Link href="https://www.willistowerswatson.com/sv-SE/Notices/information-om-oss-som-forsakringsformedlare">
                  Om oss
                </Link>
                <Link onClick={clickHandler}>Kontakta oss</Link>
                <Link href="https://www.willistowerswatson.com/sv-SE/Notices/klagomal">Klagomål</Link>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" className={clsx(styles.root, styles.secondaryLinks)}>
                <Link onClick={() => setShowTou(true)}>Terms of use</Link>
                <Link onClick={() => setShowCookie(true)}>Cookie notice</Link>
                              <Link href="https://www.wtwco.com/-/media/wtw/notices/code-of-conduct-english.pdf?modified=20200925121400">
                  Code of conduct
                </Link>
                <Link href="https://www.willistowerswatson.com/sv-SE/Notices/privacy-notice-crb">
                  Privacy notice - Willis Towers Watson Sweden AB
                  <br /> and Willis Towers Watson Oy Ab
                </Link>
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography className={styles.copyright}>
                          Copyright © {new Date().getFullYear()} WTW. All rights reserved.
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={open}
        onClose={() => toggleOpen(false)}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle id="dialog-title" color="primary">
          {contactUs.title}
        </DialogTitle>
        <DialogContent className={styles.dialog}>{contactUs.content}</DialogContent>
        <DialogActions>
          <Button onClick={() => toggleOpen(false)} color="primary" autoFocus>
            Stäng
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Footer;
